// Utility functions for TriServe Energy React App

// Format phone number to (xxx) xxx-xxxx format
export const formatPhoneNumber = (phone) => {
  const cleaned = phone.replace(/\D/g, '');
  const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    return `(${match[1]}) ${match[2]}-${match[3]}`;
  }
  return phone;
};

// Format credit card number with spaces
export const formatCreditCard = (cardNumber) => {
  const cleaned = cardNumber.replace(/\D/g, '');
  const formatted = cleaned.match(/.{1,4}/g)?.join(' ') || cleaned;
  return formatted;
};

// Format expiry date MM/YY
export const formatExpiry = (expiry) => {
  const cleaned = expiry.replace(/\D/g, '');
  if (cleaned.length >= 2) {
    return `${cleaned.slice(0, 2)}/${cleaned.slice(2, 4)}`;
  }
  return cleaned;
};

// Validate email format
export const validateEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

// Validate phone number format
export const validatePhone = (phone) => {
  const phoneRegex = /^\(\d{3}\) \d{3}-\d{4}$/;
  return phoneRegex.test(phone);
};

// Generate random customer ID
export const generateCustomerId = () => {
  const randomNumber = Math.floor(Math.random() * 1000000000).toString().padStart(9, '0');
  return `TSE-${randomNumber}`;
};

// Generate random credit score
export const generateCreditScore = (min = 650, max = 850) => {
  return Math.floor(Math.random() * (max - min + 1)) + min;
};

// Debounce function for search inputs
export const debounce = (func, wait) => {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
};

// Convert string to title case
export const toTitleCase = (str) => {
  return str.replace(/\w\S*/g, (txt) => 
    txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
  );
};

// Get current date in YYYY-MM-DD format
export const getCurrentDate = () => {
  return new Date().toISOString().split('T')[0];
};

// Calculate deposit amount based on credit score
export const calculateDeposit = (creditScore) => {
  if (creditScore >= 700) return 0;
  if (creditScore >= 650) return 75;
  if (creditScore >= 600) return 150;
  return 250;
};

// Simulate API delay for testing
export const simulateApiDelay = (ms = 1500) => {
  return new Promise(resolve => setTimeout(resolve, ms));
};
